import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import Account from 'components/PageComponents/Settings/Account/Edit'
import MainLayoutContainer from 'containers/MainLayout/index'
// themes
import { SettingsIcon } from 'themes/views/settings'
// types

const AccountSettingsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Skefto - Account Settings</title>
      </Helmet>
      <MainLayoutContainer
        label={
          <>
            <SettingsIcon />
            Account
          </>
        }>
        <Account />
      </MainLayoutContainer>
    </>
  )
}

export default AccountSettingsPage
